import { t } from "i18next";
import { ComputeFieldComponent } from "../computeFields";
import { ArtworkInAuction } from "../types";
import { SeparatedList } from "./shared/utils";
import { ComponentProps } from "react";

export const AuctionDescriptionCF: ComputeFieldComponent<
  Pick<
    ArtworkInAuction,
    | "auction"
    | "oeuvresDansVentesDescriptionNumeroLot"
    | "oeuvresDansVentesDescriptionReproduitPage"
    | "oeuvresDansVentesDescriptionNonReproduit"
  >
> = ({ input, language, ...props }) => {
  return (
    <SeparatedList
      {...props}
      lineBreak={false}
      language={language}
      commaSeparated
      input={[
        <span
          dangerouslySetInnerHTML={{
            __html: input.auction?.ventesDescriptionResume,
          }}
        />,
        input.oeuvresDansVentesDescriptionNumeroLot && (
          <>
            {t("computeField.numeroLotAbbrege")}{" "}
            {input.oeuvresDansVentesDescriptionNumeroLot}
          </>
        ),
        <SeparatedList
          {...props}
          language={language}
          commaSeparated={false}
          lineBreak={false}
          input={[
            input.oeuvresDansVentesDescriptionReproduitPage &&
              t("computeField.reproduitPageAbbrege"),
            input.oeuvresDansVentesDescriptionReproduitPage,
          ]}
        />,
        !input.oeuvresDansVentesDescriptionReproduitPage &&
          input.oeuvresDansVentesDescriptionNonReproduit && (
            <>{t("computeField.nonReproduitAbbrege")}</>
          ),
      ]}
    />
  );
};

export const RelatedAuctionsCF: ComputeFieldComponent<{
  relatedAuctions?: ComponentProps<typeof AuctionDescriptionCF>["input"][];
}> = ({ input, lineBreak = true, ...props }) => {
  if (!input.relatedAuctions || input.relatedAuctions.length === 0) {
    return <></>;
  }
  return (
    <SeparatedList
      {...props}
      input={input.relatedAuctions.map((auction, index) => (
        <AuctionDescriptionCF key={index} input={auction} {...props} />
      ))}
      lineBreak={lineBreak}
    />
  );
};
